import type { ConditionSheetResponse } from '@contracts/conditionsSheets/ConditionSheetsResponse';
import type { ExistingPermitTypeDefinition } from '@src/permitTypesManager/PermitTypeDefinition';

export type FormConditionSheet = {
  id: string;
  filePath: string;
  sendToClient: boolean;
};

export class ConditionSheets {
  private readonly sheets: ConditionSheetResponse[];

  constructor(sheets: ConditionSheetResponse[]) {
    this.sheets = sheets;
  }

  filterForJurisdiction(jurisdiction?: string): ConditionSheets {
    return jurisdiction
      ? new ConditionSheets(
          this.sheets.filter((sheet) => sheet.jurisdiction === jurisdiction),
        )
      : new ConditionSheets([]);
  }

  toDefaultForm(): FormConditionSheet[] {
    return this.sheets.map((sheet) => ({
      id: sheet.id,
      filePath: sheet.filePath,
      sendToClient: false,
    }));
  }

  toFormBasedOn(
    permitType: ExistingPermitTypeDefinition,
  ): FormConditionSheet[] {
    const sheetsIdsAsSet = new Set(permitType.conditionSheetsIds);
    return this.sheets.map((sheet) => ({
      id: sheet.id,
      filePath: sheet.filePath,
      sendToClient: sheetsIdsAsSet.has(sheet.id),
    }));
  }
}
